module.exports = __webpack_public_path__ + "static/media/press.8ac0ff12.jpg";